import type { Direction } from '../game/types'

export function DPad({ onDirection }: { onDirection: (direction: Direction) => void }) {
  const button = (direction: Direction, label: string) => (
    <button type="button" className={`dpad-key dpad-${direction}`} aria-label={label} onPointerDown={(event) => { event.preventDefault(); onDirection(direction) }}>
      <span aria-hidden="true">{direction === 'up' ? '↑' : direction === 'down' ? '↓' : direction === 'left' ? '←' : '→'}</span>
    </button>
  )
  return <div className="dpad" aria-label="Directional controls">
    {button('up', 'Up')}{button('left', 'Left')}{button('right', 'Right')}{button('down', 'Down')}
  </div>
}
